type TOptionId = {
  id: string | null;
  options: any[];
  optionsIdField?: string;
  optionsNameField?: string;
};

export default function findOptionNameById({
  id,
  options,
  optionsIdField = 'id',
  optionsNameField = 'name',
}: TOptionId) {
  if (id === null) return '';

  const viewOption = options.find((option) => option[optionsIdField] === id);
  return viewOption ? (viewOption[optionsNameField] as any) : '';
}
